import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import axios from 'axios';
import queryString from 'query-string';

// components
import Calendar from '../components/singlets/EventCalendar';
import List from '../components/singlets/EventList';
import SidebarNav from '../components/navigation/SidebarNavGrouped';
import VideoList from '../components/singlets/VideoList';

class Page extends Component {
  state = {
    isLoaded: false, display: 'list', events: [], accessToken: null, cat: null
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('#main').classList.add('hero');

    const libcalAPI = process.env.REACT_APP_LIBCALAPI;
    const calId = process.env.REACT_APP_CALID;

    const body = {
      'grant_type': 'client_credentials',
      'client_id': process.env.REACT_APP_CLIENTID,
      'client_secret': process.env.REACT_APP_CLIENTSECRET
    };

    axios.post(libcalAPI+'/oauth/token', body)
    .then(res => {
      let token = res.data.access_token;
      // console.log(token);
      let url = window.location.search;
      let params = queryString.parse(url);
      let catId = params.catid;

      axios.get(libcalAPI+'/events?cal_id='+calId+'&limit=500&days=120&category='+catId, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(res => {
        // console.dir(res);
        const now = new Date();

        res.data.events.forEach(element => {
          const ed = new Date(element.end);

          if (ed.getTime() > now.getTime()) {
            this.state.events.push(element);

            element.category.forEach(category => {
              if(category.id === Number(catId)) {
                this.setState({ cat: category.name });
              }
            })
          }
        });

        this.setState({ isLoaded: true });
      })
      .catch(function (error) {
        console.dir(error);
      });

    });
  }

  switchView = (d) => {
    let calBtn = document.querySelector('.calBtn');
    let lstBtn = document.querySelector('.lstBtn');

    this.setState({ display: d });

    if (d === 'calendar') {
      calBtn.classList.add('active');
      lstBtn.classList.remove('active');
    } else {
      calBtn.classList.remove('active');
      lstBtn.classList.add('active');
    }
  }

  render() {
    const { isLoaded, display, events, cat } = this.state;

    return (
      <>
      <div id="hero">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <img src={process.env.PUBLIC_URL + '/global/images/ilearn-logo.png'} alt="iLEARN: Innovation, Learning Excellence, and Academic Resource Network" />
              <p>Innovation, Learning Excellence, and Academic Resource Network</p>
            </div>
          </div>
        </div>
      </div>

      <div className="homepage">
        <div className="container">
          <div className="row">

            <div className="col-9 contentCont">

              <h1>{ cat } Events</h1>
              {/* <p>Select a date from the calendar to get more information on each of the events, or change the view with the buttons to view  <span className="highlight" onClick={ () => this.switchView('calendar') }>Calendar</span> or <span className="highlight" onClick={ () => this.switchView('list') }>List</span> views.</p> */}

              {/* <div className="buttonGroup">
                <button onClick={ () => this.switchView('list') } className="lstBtn"><i className="fa fa-th-list"></i></button>
                <button onClick={ () => this.switchView('calendar') } className="calBtn active"><i className="fa fa-calendar"></i></button>
              </div> */}

              {(isLoaded && display === 'calendar') && (
                <Calendar events={ events } />
              )}

              {display === 'list' && (
                <List events={ events } limit="10" loadmore="true" />
              )}
            </div>

            <div className="col-3 sideCont">
              <SidebarNav />
              <VideoList count="6" />
            </div>

          </div>
        </div>
      </div>
      </>
    );
  }
}

export default Page;